import type { PushReceivedSource } from '@lemoment/shared';

const TAP_SOURCES: ReadonlySet<PushReceivedSource> = new Set([
  'background-tap',
  'cold-start-tap',
]);

export const isTapSource = (source: PushReceivedSource): boolean =>
  TAP_SOURCES.has(source);

export const isForegroundSource = (source: PushReceivedSource): boolean =>
  source === 'foreground';
